import type { ReceiptShare } from '@/features/receipts/components/ReceiptPrintPreview';
import { publicFormUrl } from '../public/publicUrls';

/** WhatsApp share target for an event receipt: the participant's phone and their /p page opened on the receipt tab */
export function eventReceiptShare(
  participant: { public_token: string; minister?: { full_name?: string | null } | null; guest?: { full_name?: string | null } | null },
  phone: string | null,
  receiptNumber: number,
): ReceiptShare {
  return {
    phone,
    name: participant.minister?.full_name ?? participant.guest?.full_name ?? 'Participante',
    url: `${publicFormUrl(participant.public_token)}?recibo=${receiptNumber}`,
  };
}
